import $ from "jquery";

const ServiceCardHoverer = () => {
  const init = () => {
    CardHover();
    CardOnLoad();
  };

  const CardHover = () => {
    const el = {
      card: "div.service-card",
      cardImage: "img.service-card_image",
      cardImageHover: "img.service-card_image-hover",
      cardContent: "div.service-card_content",
    };

    $(el.card).hover(
      function () {
        $(this).find($(el.cardImage)).addClass("hidden");
        $(this).find($(el.cardContent)).addClass("show");
      },
      function () {
        $(this).find($(el.cardImage)).removeClass("hidden");
        $(this).find($(el.cardContent)).removeClass("show");
      }
    );
  };

  const CardOnLoad = () => {
    const el = {
      card_1: "div.service-card.card-1",
      card_2: "div.service-card.card-2",
      card_3: "div.service-card.card-3",
      card_4: "div.service-card.card-4",
    };

    $(window).scroll(function () {
      function elementScrolled(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        return elemTop <= docViewBottom && elemTop >= docViewTop;
      }

      if (elementScrolled(".service-card")) {
        setTimeout(() => {
          $(el.card_1).addClass('slideUp')
        }, 400);

        setTimeout(() => {
          $(el.card_2).addClass('slideUp')
        }, 500);

        setTimeout(() => {
          $(el.card_3).addClass('slideUp')
        }, 600);

        setTimeout(() => {
          $(el.card_4).addClass('slideUp')
        }, 700);
      }
    });
  };

  init();
};

try {
  ServiceCardHoverer();
} catch (error) {
  console.log(error);
}
